import React from "react";

const PaperDarkBG = ({ children, className = "", fullHeight = false}) => {
  return (
    <div
      className={`${fullHeight ? "min-h-screen" : ""} w-full text-white bg-slate-900 ${className}`}
    >
      {children}
    </div>
  );
};

export default PaperDarkBG;
